<template>
  <div class="home">
    <div class="centerHome">
      <div class="banner">
        <div class="search">
          <div class="centerHome">
            <el-radio-group v-model="select">
              <el-radio-button label="1" class="search-radio"
                >Journal</el-radio-button
              >
              <el-radio-button label="2" class="search-radio"
                >Article</el-radio-button
              >
              <el-radio-button label="3" class="search-radio"
                >keyword</el-radio-button
              >
            </el-radio-group>
            <div style="margin-top: 15px">
              <el-input
                placeholder="Please enter the content"
                v-model="input"
                class="input-with-select"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="handleSearch"
                ></el-button>
              </el-input>
            </div>
          </div>
        </div>
        <div class="bannerText">
          <div class="bannerTitle">
            YIBO Research & Academic Press Pte. Ltd.
          </div>
          <!-- <div class="bannerDesc">艺博科研学术出版社</div> -->
        </div>
      </div>
    </div>
    <!-- <div class="search">
      <div class="centerHome">
        <div class="search-box">
          <div style="margin-top: 15px">
            <el-input
              placeholder="Please enter the content"
              v-model="input"
              class="input-with-select"
            >
              <el-select
                v-model="select"
                slot="prepend"
                placeholder="Please select"
              >
                <el-option label="Journal Title" value="1"></el-option>
                <el-option label="Article Title" value="2"></el-option>
                <el-option label="keyword" value="3"></el-option>
              </el-select>
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="handleSearch"
              ></el-button>
            </el-input>
          </div>
        </div>
      </div>
    </div> -->

    <div class="centerHome">
      <div class="journalList">
        <h1 class="title">Journals</h1>
        <div class="journalBox">
          <div
            class="journalItem"
            v-for="(item, index) in journalList"
            :key="index"
          >
            <div class="journalImg">
              <img :src="item.thumbnail.url" alt="" />
            </div>
            <div class="journalText">
              <!-- @click="toDetailPages(item)" -->
              <h3 class="journalTitle">
                <a :href="journalLink(item)">
                  {{ item.title }}
                </a>
              </h3>
              <p class="journalDesc" v-show="item.onlineIssn">
                E-ISSN: {{ item.onlineIssn }}
              </p>
              <p class="journalDesc" v-show="item.printIssn">
                P-ISSN: {{ item.printIssn }}
              </p>
              <!-- <p class="journalDesc">Publication Frequency:</p>
              <p class="journalDesc">
                {{ item.publicationFrequency }}
              </p>
              <div class="other">
                <p class="journalDesc" v-show="item.citescore">
                  Citescore: {{ item.citescore }}
                </p>
                <p class="journalDesc" v-show="item.frequency">
                  Impact Factor: {{ item.frequency }}
                </p>
              </div> -->
            </div>
          </div>
        </div>
        <div class="more" v-if="journalList.length > 0">
          <span @click="toJournalList">
            more journals <i class="el-icon-d-arrow-right"></i>
          </span>
        </div>
      </div>
      <div class="articleList">
        <h1 class="title">Latest Articles</h1>
        <div class="box" :class="{ visible: visible }">
          <div class="articleBox">
            <!-- @click="toArticleDetail(item)" -->
            <div
              class="articleItem"
              v-for="(item, index) in articleList"
              :key="index"
            >
              <div class="journalName">{{ item.journalTitle }}</div>
              <div class="onlineTime">
                <i class="el-icon-date"></i>{{ item.datePublished }}
              </div>
              <a :href="articleLink(item)">
                <div
                  class="articleTitle"
                  style="text-align: left"
                  v-html="item.fullTitle"
                ></div>
              </a>
              <div class="articleType">{{ item.section }}</div>
              <br />
              <div class="doi">{{ item.doi }}</div>
            </div>
          </div>
          <div class="more" v-if="articleList.length > 0">
            <span @click="toJournalList">
              more articles <i class="el-icon-d-arrow-right"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="contact">
      <div class="center">
        <div class="left">
          <h2>Contact Us</h2>
          <div>
            <div class="item"><span v-html="contact[0]"></span></div>
            <div class="item"><span v-html="contact.addr"></span></div>
            <div class="item"><span v-html="contact.phone"></span></div>
            <div class="item"><span v-html="contact.email"></span></div>
          </div>
        </div>
        <div class="logo">
          <img src="@/assets/images/logo-w.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from '@/utils/http';
import { journalLink, articleLink } from '@/utils/addLink';
export default {
  name: 'HomeView',
  components: {},
  data() {
    return {
      input: '',
      select: '1',
      journalList: [],
      articleList: [],
      // loading: false,
      // loadArticles: false,
      visible: false,
      loading: false,
      contact: {},
    };
  },
  mounted() {
    this.getJournalList();
    this.getArticlesList();
    this.getInfo();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.visible = true;
          observer.unobserve(entry.target);
        }
      });
    });

    const target = this.$el.querySelector('.articleBox');
    observer.observe(target);
  },
  methods: {
    journalLink,
    articleLink,
    getJournalList() {
      // this.loading = true;
      get('index/api/v1/journals?count=6&offset=0&isIndex=true').then((res) => {
        if (res.code == 200) {
          this.journalList = res.data.items;
          this.$nextTick(() => {
            const p = document.querySelectorAll('.journalDesc p');
            p.forEach((p) => {
              p.style.lineHeight = '1.5rem';
            });
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getArticlesList() {
      // this.loadArticles = true;
      get('/index/api/v1/submissions/allLatest?count=8&offset=0').then(
        (res) => {
          if (res.code == 200) {
            this.articleList = res.data.items;
          } else {
            this.$message.error(res.message);
          }
        },
      );
    },

    toJournalList() {
      this.$router.push({
        path: '/journalList',
      });
    },
    toDetailPages(item) {
      localStorage.setItem('journal', JSON.stringify(item.path));
      if (item.isToOJS) {
        window.open(
          `https://ojs.yibo-pub.com/index.php/${item.path}`,
          '_blank',
        );
      } else {
        this.$router.push({
          path: '/detailPages/' + item.path,
          query: {
            journal: item.path,
          },
        });
      }
    },
    toArticleDetail(item) {
      if (item.isToOJS) {
        window.open(
          `https://ojs.yibo-pub.com/index.php/${item.journalPath}/article/view/${item.id}`,
          '_blank',
        );
      } else {
        this.$router.push({
          path: '/detailPages/' + item.journalPath + '/articalDetail',
          query: {
            journal: item.journalPath,
            id: item.id,
          },
        });
      }
    },
    handleSearch() {
      if (this.select == '1') {
        this.$router.push({
          name: 'journalList',
          query: {
            searchCriteria: this.input,
          },
        });
      } else {
        this.$router.push({
          name: 'advancedSearch',
          query: {
            searchCriteria: this.input,
            type: this.select,
          },
        });
      }
    },
    getInfo() {
      this.loading = true;
      get('qq/api/v1/site/about')
        .then((res) => {
          if (res.code == 200) {
            if (res.data.length > 0) {
              // this.info = res.data[0].content[0];
              this.contact = res.data[1].content;
            }
            // this.info = res.data[0].content[0];
            // this.contact = res.data[1].content;
          } else {
            this.$message.error(res.message);
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
@import url('@/assets/css/commen.css');
.home {
  background-color: #ffffff;
  .centerHome {
    width: 98%;
    max-width: 1400px;
    margin: auto;
    padding: 10px 0;
    @media (max-width: 996px) {
      width: 100vw;
      max-width: 100%;
      margin: 0 4px;
    }
    .banner {
      width: 1400px;
      height: 200px;
      background: url('@/assets/images/banner5.jpg') #ffffff no-repeat center;
      background-size: cover;
      box-shadow: #ececec 0px 0px 10px;
      position: relative;
      overflow: hidden;
      @media (max-width: 996px) {
        width: 100%;
        height: 150px;
      }
      .search {
        position: absolute;
        top: 51%;
        left: 37%;
        width: 58%;
        transform: translate(-50%, -50%);
        animation: slide-upss-41c313cc 1s forwards;
        @keyframes slide-upss {
          0% {
            top: 70%;
            opacity: 0;
          }
          100% {
            top: 51%;
            opacity: 1;
          }
        }
        @media (max-width: 996px) {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          transform: translate(0, 0);
          animation: slide-upss 1s forwards;
          @keyframes slide-upss {
            0% {
              top: 70%;
              opacity: 0;
            }
            100% {
              top: 0%;
              opacity: 1;
            }
          }
        }
        .centerHome {
          width: 100%;
          max-width: 1400px;
          margin: auto;
          @media (max-width: 996px) {
            position: none;
            width: 80%;
            max-width: 80%;
          }
        }
      }
      .bannerText {
        position: absolute;
        top: 50%;
        left: 80%;
        transform: translate(-50%, -50%);
        animation: slide-up 1s forwards;
        @media (max-width: 996px) {
          display: none;
        }
        @keyframes slide-up {
          0% {
            top: 70%;
            opacity: 0;
          }
          100% {
            top: 50%;
            opacity: 1;
          }
        }

        .bannerTitle {
          font-size: 24px;
          font-weight: bold;
          // margin-bottom: 10px;
          line-height: 38px;
          width: auto;
          // border-bottom: 2px double #585858;
        }
        .bannerDesc {
          font-size: 15px;
          line-height: 20px;
          color: #232323;
        }
      }
    }
    .journalList {
      .journalBox {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        align-items: center;
        min-height: 200px;
        animation: slide-ups 0.5s forwards;
        display: flex;
        justify-content: space-between;
        @keyframes slide-ups {
          0% {
            top: 80%;
            opacity: 0;
          }
          100% {
            top: 0;
            opacity: 1;
          }
        }
        .journalItem {
          width: 16%;
          // height: 350px;
          margin: 10px auto;
          background: #ffffff;
          box-shadow: #ececec 0px 0px 10px;
          padding: 15px 0px;
          overflow: hidden;
          // display: flex;
          // justify-content: space-between;
          border-radius: 3px;
          border: 1px solid #ffffff;
          box-sizing: border-box;
          transition: all 0.6s;
          @media (max-width: 996px) {
            width: 100%;
            height: auto;
            padding: 10px;
            margin: 0 10px 10px;
          }
          .journalImg {
            margin: auto;
            width: 80%;
            height: auto;
            overflow: hidden;
            flex-shrink: 0;
            img {
              width: 100%;
              height: auto;
            }
          }
          .journalText {
            width: 100%;
            // padding: 5px 0 0 10px;
            color: #333;
            position: relative;
            .journalTitle {
              width: 95%;
              margin: 0 auto;
              height: 40px;
              text-align: center;
              margin-bottom: 6px;
              cursor: pointer;
              // 超过两行显示省略号
              display: -webkit-box;
              -webkit-line-clamp: 2; /* 限制显示的行数 */
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;

              @media (max-width: 996px) {
                font-size: 15px;
              }
            }
            .journalDesc {
              line-height: 1.3;
              font-size: 14px;
              color: #585858;
              text-align: center;
            }
            .other {
              position: absolute;
              // left: 0;
              bottom: 0px;
            }
          }
        }
        .journalItem:hover {
          transition: all 0.6s;
          border: 1px solid #f19600;
          // box-sizing: border-box;
          .journalText {
            .journalTitle {
              color: #f19600;
            }
          }
        }
      }
      .more {
        width: 100%;
        margin-bottom: 20px;
        text-align: center;
        margin-top: 15px;
        color: #666;
        cursor: pointer;
        transition: all 0.6s;
        i {
          transform: rotate(90deg);
        }
      }
      .more:hover {
        margin-top: 20px;
        transition: all 0.6s;
        color: #004fa3;
      }
    }
    .articleList {
      .box {
        opacity: 0;
        transform: translateY(50px);
        transition: opacity 1.5s ease, transform 1.5s ease;
        .articleBox {
          display: flex;
          flex-wrap: wrap;
          min-height: 200px;
          .articleItem {
            transition: all 0.6s;
            width: calc(25% - 30px);
            padding: 20px;
            box-sizing: border-box;
            margin: 15px;
            border: 1px solid #ececec;
            @media (max-width: 996px) {
              width: 100%;
              height: auto;
              padding: 10px;
              margin: 10px;
            }
            .journalName {
              font-size: 14px;
              color: #0f7497;
              margin-bottom: 5px;
            }
            .onlineTime {
              color: #cccccc;
              font-size: 14px;
              margin-bottom: 5px;
              i {
                margin-right: 5px;
              }
            }
            .articleTitle {
              font-size: 16px;
              font-weight: 550;
              justify-content: space-between;
              line-height: 1.5;
              margin-bottom: 5px;
              cursor: pointer;
              height: 76px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
            }
            .articleType {
              font-size: 14px;
              color: #ffffff;
              padding: 3px 8px;
              border-radius: 5px;
              text-align: center;
              background: #f19600;
              display: inline-block;
              margin-bottom: 5px;
            }
            .doi {
              // display: block;
              color: #585858;
              font-size: 14px;
              word-wrap: break-word;
            }
          }
          .articleItem:hover {
            // border: 1px solid #f19600;
            box-shadow: #585858 0px 0px 10px;
            transition: all 0.6s;
            .articleTitle {
              color: #f19600;
              text-decoration: underline;
            }
          }
        }
        .more {
          width: 100%;
          margin-bottom: 20px;
          text-align: center;
          margin-top: 15px;
          color: #666;
          cursor: pointer;
          transition: all 0.6s;
          i {
            transform: rotate(90deg);
          }
        }
        .more:hover {
          margin-top: 20px;
          transition: all 0.6s;
          color: #004fa3;
        }
      }
      .visible {
        opacity: 1; /* 可见时的状态 */
        transform: translateY(0); /* 回到原始位置 */
      }
    }
  }
  .contact {
    background-color: #004fa3;
    color: #ffffff;
    width: 100%;
    position: absolute;
    bottom: 60px;
    left: 0;
    padding: 20px 0;
    .center {
      width: 98%;
      max-width: 1400px;
      margin: auto;
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .left {
        width: 50%;
        h2 {
          margin-bottom: 30px;
        }
      }
      .logo {
        width: 200px;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
<style scoped>
.el-select {
  width: 130px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
@media (max-width: 996px) {
  h1 {
    font-size: 20px;
  }
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    height: 26px;
    line-height: 25px;
    width: 25px;
  }
  .el-input__inner {
    height: 30px !important;
  }
  .el-input--medium .el-input__inner,
  .el-input__inner {
    height: 100% !important;
  }
  .el-input-group__append,
  .el-input-group__prepend {
    height: 100% !important;
  }
}
</style>
